import { IntegrationInstanceType } from './integration_instance_type.js';

export function name(instanceType: IntegrationInstanceType): string {
  switch (instanceType) {
    case IntegrationInstanceType.Sandbox:
      return 'Sandbox';
    case IntegrationInstanceType.Prod:
      return 'Prod';
  }
}
